(function(){
  if(document.documentElement.classList.contains('shopify-design-mode'))return;
  if(new URLSearchParams(window.location.search).has('preview_theme_id'))return;
  var holder=document.querySelector('[data-rayo-country]');
  var form=document.getElementById('RayoNigeriaDefault');
  if(!holder||!form)return;
  try {
    if(window.localStorage.getItem('rayoCountryInitialized')!==null)return;
    window.localStorage.setItem('rayoCountryInitialized','1');
    if(holder.dataset.rayoCountry==='NG')return;
    form.submit();
  } catch(error) {
    // If storage is disabled, keep the shopper's existing country to avoid a redirect loop.
  }
})();